import { render, staticRenderFns } from "./StartSurveyFromForm.vue?vue&type=template&id=458f8881&scoped=true"
import script from "./StartSurveyFromForm.vue?vue&type=script&lang=js"
export * from "./StartSurveyFromForm.vue?vue&type=script&lang=js"
import style0 from "./StartSurveyFromForm.vue?vue&type=style&index=0&id=458f8881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f8881",
  null
  
)

export default component.exports